import { useState, useEffect } from "react";
import PrintSVG from "../../utils/assets/client/printer.svg";
import ProfileSVG from "../../utils/assets/client/user.svg";
import NotesSVG from "../../utils/assets/client/writing.svg";
import ProfileIcon from "../../components/client/ProfileIcon";
import { fetchEstimatesById } from "../../actions/client/estimates";
import { useParams } from "react-router-dom";
import {
  saveEstimateNotes,
  getEstimateNotes,
} from "../../actions/client/estimates";
import { toast } from "react-toastify";
import Badge from "../../components/admin/Badge";
import Comments from "../../components/client/Comments";
import { fetchTicketNotes, postTicketNotes } from "../../actions/admin/tickets";
import { getEstimatePDF } from "../../actions/admin/estimates";

const EstimatesDetailsPage = () => {
  const [estimateDetails, setEstimateDetails] = useState([]);
  const [notesData, setNotesData] = useState([]);
  const [noteInput, setNoteInput] = useState("");
  const { id } = useParams();

  useEffect(() => {
    getAllData();
    return () => {};
  }, []);

  const getAllData = async () => {
    const token = localStorage.getItem("token");
    const response = await fetchEstimatesById(token, id);
    setEstimateDetails(response.data);
    const estimatesNotes = await getEstimateNotes(token, response.data.id);
    setNotesData(estimatesNotes.data);
  };

  const handleNotesSubmit = () => {
    const authtoken = localStorage.getItem("token");

    const dataSet = {
      estimate_id: estimateDetails.id,
      note: noteInput,
      is_internal: false,
    };
    saveEstimateNotes(authtoken, dataSet).then(async (res) => {
      if (!res.success === true) {
        toast.error(res.data);
      }
      toast.success(res.data);
      const estimatesNotes = await getEstimateNotes(
        authtoken,
        estimateDetails.id
      );
      setNotesData(estimatesNotes.data);
    });

    setNoteInput("");
  };

  const handleComments = async (note) => {
    const token = localStorage.getItem("token");

    const data = {
      estimate_id: id,
      note,
    };

    await saveEstimateNotes(token, data).then((res) => {
      if (res.success == true) {
        toast.success("Note Added Successfully");
        getEstimateNotes(token, id).then((res) => {
          setNotesData(res.data);
        });
      } else {
        toast.error("Something went wrong");
      }
    });
  };

  const leadValue = parseFloat(
    estimateDetails?.lead?.lead_items[0]?.lead_value
  );
  let twentyPercent;
  let total;
  if (!isNaN(leadValue)) {
    twentyPercent = (leadValue * 20) / 100;
    total = leadValue + twentyPercent;

    console.log("20% of the lead value is:", twentyPercent.toFixed(2)); // Format to two decimal places
  }

  const handleEstimateDownload = async () => {
    const token = localStorage.getItem("token");
    try {
      const pdfBlob = await getEstimatePDF(token, id);
      // Create a URL for the blob
      const url = window.URL.createObjectURL(
        new Blob([pdfBlob], { type: "application/pdf" })
      );
      // Open the PDF in a new tab
      window.open(url, "_blank");
    } catch (error) {
      console.error("Error opening the PDF:", error);
    }
  };

  return (
    <div className="bg_color_gray " style={{ height: "100vh" }}>
      <div className="mx-4 mx-lg-4 mx-md-4 ">
        <div className="row mt-3">
          <h3 className="">Estimate #{estimateDetails?.id}</h3>
        </div>
        <div className="">
          <div className="row bg-white shadow rounded lg-device_screen">
            <div className="px-5 py-4  d-flex">
              <div className="col-6 d-flex justify-content-start align-items-center">
                <div
                  className="border bg-white d-flex justify-content-center align-items-center mx-2"
                  style={{
                    borderRadius: "50%",
                    overflow: "hidden",
                    maxWidth: "90px",
                    maxHeight: "90px",
                  }}
                >
                  <img
                    className="p-2"
                    src={ProfileSVG}
                    width={85}
                    alt="profile"
                  />
                </div>
                <div className="d-flex flex-column mx-3">
                  <p className="txt-head mb-0">
                    {estimateDetails?.lead?.customer?.first_name}{" "}
                    {estimateDetails?.lead?.customer?.last_name}
                  </p>
                  <span className="">
                    Email: {estimateDetails?.lead?.customer?.email}
                  </span>
                  <span className="">
                    Mobile : {estimateDetails?.lead?.customer?.phone}
                  </span>
                  <span className="">
                    Address : {estimateDetails?.lead?.customer?.address},{" "}
                    {estimateDetails?.lead?.customer?.city}{" "}
                    {estimateDetails?.lead?.customer?.state},{" "}
                    {estimateDetails?.lead?.customer?.country} -{" "}
                    {estimateDetails?.lead?.customer?.zip_code}
                  </span>
                </div>
              </div>
              <div className="col-6 d-flex justify-content-end text-end align-items-center">
                <div className="d-flex flex-column">
                  <p className="m-0 mb-1 ">
                    Estimate Status :{" "}
                    <span
                      className="badge p-2"
                      style={{ backgroundColor: estimateDetails?.color_code }}
                    >
                      {estimateDetails?.status}
                    </span>
                  </p>{" "}
                  <span className="">
                    Created date :{" "}
                    {estimateDetails?.created_at
                      ? new Date(
                          estimateDetails?.created_at
                        ).toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        })
                      : "-"}
                  </span>
                  <span className="">Store Location : Repair Desk</span>
                  <button
                    onClick={() => handleEstimateDownload()}
                    className="btn  bg-black text-white py-2 px-4 mt-3 d-flex justify-content-center align-items-center"
                  >
                    {" "}
                    <img
                      src={PrintSVG}
                      width={17}
                      style={{ marginRight: "5px" }}
                      alt="print"
                    />
                    <span className="mx-2">Print</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* sm device  start*/}
          <div className="row bg-white shadow md-device_screen">
            <div className=" py-4 d-flex">
              <div className="col-lg-6 col-md-6 col-xs-12 col-sm-12 d-flex justify-content-center align-items-center">
                <div className="row ">
                  <div className="col-12 d-flex flex-column justify-content-center align-items-center">
                    <div
                      className="border bg-white d-flex justify-content-center align-items-center mx-2"
                      style={{
                        borderRadius: "50%",
                        overflow: "hidden",
                        maxWidth: "90px",
                        maxHeight: "90px",
                      }}
                    >
                      <img
                        className="p-2"
                        src={ProfileSVG}
                        width={85}
                        alt="profile"
                      />
                    </div>
                    <p className="f-24 text-center mt-2 mb-0">
                      {estimateDetails?.lead?.customer?.first_name}{" "}
                      {estimateDetails?.lead?.customer?.last_name}
                    </p>
                  </div>
                  <div className="col-12">
                    <div className="d-flex flex-column justify-content-center align-items-center text-center mt-2 p-2 pt-0">
                      <p className="mb-0">
                        Email: {estimateDetails?.lead?.customer?.email}
                      </p>
                      <span className="">
                        Mobile : {estimateDetails?.lead?.customer?.phone}
                      </span>
                      <span className="">
                        Address : {estimateDetails?.lead?.customer?.address}
                      </span>
                      <span className="">
                        Created date :{" "}
                        {estimateDetails?.created_at
                          ? new Date(
                              estimateDetails?.created_at
                            ).toLocaleDateString("en-GB", {
                              day: "2-digit",
                              month: "short",
                              year: "numeric",
                            })
                          : "-"}
                      </span>
                      <span className="">Store Location : Repair Desk</span>
                      <button className="btn w-75  bg-black text-white py-2 px-4 mt-3 d-flex justify-content-center align-items-center">
                        {" "}
                        <img
                          src={PrintSVG}
                          width={17}
                          style={{ marginRight: "5px" }}
                          alt="print"
                        />
                        <span className="mx-2">Print</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="my-3">
          <div className="row rounded shadow bg-white overflow-hidden">
            <p className="txt-head bg-black text-white px-3  p-2 mb-0">
              Estimate Item (s)
            </p>
            <table className="table   table-hover">
              <thead>
                <tr>
                  <td style={{ paddingLeft: "15px" }}>Device</td>
                  <td>Device Issue</td>
                  <td>IMEI/Serial</td>
                  <td>Type</td>
                  <td>Estimated Date</td>
                  <td>Price Estimate</td>
                  <td>Tax</td>
                  <td>Status</td>
                </tr>
              </thead>
              <tbody>
                {estimateDetails?.lead?.lead_items.length > 0 &&
                  estimateDetails?.lead?.lead_items.map((item) => {
                    return (
                      <tr>
                        <td style={{ paddingLeft: "15px" }}>
                          {" "}
                          <span style={{ fontWeight: "400" }}>
                            {item?.brand?.name} {item.devices[0].title}
                          </span>{" "}
                        </td>
                        <td>
                          {item.defects &&
                            item.defects.map((defect) => {
                              return (
                                <span style={{ fontWeight: "400" }}>
                                  {defect.title}{" "}
                                </span>
                              );
                            })}
                        </td>
                        <td>
                          <span style={{ fontWeight: "400" }}>
                            {item.imei_no ? item.imei_no : item.serial_no}
                          </span>
                        </td>
                        <td>
                          <span style={{ fontWeight: "400" }}>
                            {item?.delivery_type}{" "}
                          </span>
                        </td>
                        <td>
                          <span style={{ fontWeight: "400" }}>
                            {item.created_at
                              ? new Date(item.created_at).toLocaleDateString(
                                  "en-GB",
                                  {
                                    day: "2-digit",
                                    month: "short",
                                    year: "numeric",
                                  }
                                )
                              : "-"}
                          </span>
                        </td>
                        <td>
                          <span style={{ fontWeight: "400" }}>
                            £ {item.lead_value}
                          </span>
                        </td>
                        <td>
                          <span style={{ fontWeight: "400" }}>
                            £ {item.tax}
                          </span>
                        </td>
                        <td>
                          {" "}
                          <span
                            style={{
                              backgroundColor: estimateDetails?.color_code,
                            }}
                            className="badge p-2"
                          >
                            {estimateDetails?.status}
                          </span>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
            <div className="rounded mb-3 total_card bg_color_gray d-flex flex-column justify-content-center text-end p-3 f-16">
              <div className="d-flex justify-content-between align-items-center">
                <span>Sub Total :</span>
                <span>£ {estimateDetails?.total_price}</span>
              </div>
              <div className="d-flex justify-content-between align-items-center">
                <span>Discount :</span>
                <span>£ 0</span>
              </div>
              <div className="d-flex justify-content-between align-items-center">
                <span>GST : </span>
                <span>
                  £ {estimateDetails?.total_tax}
                  {/* {(estimateDetails?.lead?.lead_items[0]?.lead_value * 20) /
                    100} */}
                </span>
              </div>
              <hr />
              <div className="d-flex justify-content-between align-items-center">
                <span className="text-dark" style={{ fontSize: "20px" }}>
                  Total :{" "}
                </span>
                <span className="text-dark" style={{ fontSize: "20px" }}>
                  £ {estimateDetails?.total_price + estimateDetails?.total_tax}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="mb-5">
          <Comments
            notesData={notesData}
            header={"Estimate History"}
            submit={handleComments}
          />
        </div>
      </div>
    </div>
  );
};

export default EstimatesDetailsPage;
